import service from "../service";

export interface QuestionAnswerAgentListParams {
  page?: number;
  key?: string;
  intPageSize?: number;
}

export interface QuestionAnswerAgentItem {
  Id?: string | number;
  场景名称?: string;
  名称?: string;
  提示词?: string;
  ISDELETED?: boolean;
  [key: string]: any;
}

export default {
  list(params: QuestionAnswerAgentListParams = {}, data: any[] = []): Promise<any> {
    return service({
      method: "POST",
      url: "/问答智能体/列表查询",
      params: {
        page: params.page || 1,
        key: params.key || "",
        intPageSize: params.intPageSize || 50,
      },
      data,
    });
  },

  detail(id: string | number): Promise<any> {
    return service({
      method: "GET",
      url: "/问答智能体/ID查询",
      params: { id },
    });
  },

  save(data: QuestionAnswerAgentItem): Promise<any> {
    return service({
      method: "POST",
      url: "/问答智能体/新增或更新问答智能体",
      data,
    });
  },

  delete(id: string | number): Promise<any> {
    return service({
      method: "DELETE",
      url: "/问答智能体/ID删除",
      params: { id },
    });
  },
};
